// extracted by mini-css-extract-plugin
export default {"footerCopy":"_5jrRMMHTFL13ogXFThbeWV","footerAction":"_5tsPY2J2mRYKR6PgsTeyB2"};